// Spelt out per game, this drifted apart.

/** Returns the unhook. */
export function onPageVisibility(handlers: {
  hidden: () => void;
  visible: () => void;
}): () => void {
  const listener = () =>
    document.hidden ? handlers.hidden() : handlers.visible();
  document.addEventListener('visibilitychange', listener);
  return () => document.removeEventListener('visibilitychange', listener);
}
